exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agency-number-notice[data-v-174197c3]{padding:16px 20px;margin-bottom:20px;background:#fff8e6;border:1px solid #ead9a7;border-radius:5px;color:#654d17;font-size:13px;line-height:1.7}.agency-number-notice strong[data-v-174197c3]{display:block}.agency-number-notice a[data-v-174197c3],.agency-number-notice button[data-v-174197c3]{display:inline-block;margin:8px 16px 0 0;text-decoration:underline;color:inherit}.agency-number-notice button[data-v-174197c3]:disabled{opacity:.6}", ""]);

// exports
